import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
  ACQUISITION_DETAIL_LIST,
  ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST,
  ACQUISITION_DETAIL_DETAIL,
  ACQUISITION_DETAIL_SEARCH_PROJECT_LIST,
  ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST,
  ACQUISITION_DETAIL_SEARCH_YEAR_LIST,
  ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST,
  ACQUISITION_DETAIL_SEARCH_DEMAND_LIST
} from '../actions';
import {
  AcquisitionDetailListSuccess,
  AcquisitionDetailListError,
  AcquisitionDetailSearchArticleGroupListSuccess,
  AcquisitionDetailSearchArticleGroupListError,
  AcquisitionDetailSearchProjectListSuccess,
  AcquisitionDetailSearchProjectListError,
  AcquisitionDetailSearchAcquisitionListSuccess,
  AcquisitionDetailSearchAcquisitionListError,
  AcquisitionDetailSearchYearListSuccess,
  AcquisitionDetailSearchYearListError,
  AcquisitionDetailDetailSuccess,
  AcquisitionDetailDetailError,
  AcquisitionDetailSearchAcquisitionDetailTypeListSuccess,
  AcquisitionDetailSearchAcquisitionDetailTypeListError,
  AcquisitionDetailSearchDemandListSuccess,
  AcquisitionDetailSearchDemandListError
} from '../actions';

export function* watchAcquisitionDetailList() {
  yield takeEvery(ACQUISITION_DETAIL_LIST, onAcquisitionDetailList);
}

export function* watchAcquisitionDetailSearchArticleGroupList() {
  yield takeEvery(ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST, onAcquisitionDetailSearchArticleGroupList);
}

export function* watchAcquisitionDetailDetail() {
  yield takeEvery(ACQUISITION_DETAIL_DETAIL, onAcquisitionDetailDetail);
}

export function* watchAcquisitionDetailSearchProjectList() {
  yield takeEvery(ACQUISITION_DETAIL_SEARCH_PROJECT_LIST, onAcquisitionDetailSearchProjectList);
}

export function* watchAcquisitionDetailSearchAcquisitionList() {
  yield takeEvery(ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST, onAcquisitionDetailSearchAcquisitionList);
}

export function* watchAcquisitionDetailSearchYearList() {
  yield takeEvery(ACQUISITION_DETAIL_SEARCH_YEAR_LIST, onAcquisitionDetailSearchYearList);
}

export function* watchAcquisitionDetailSearchAcquisitionDetailTypeList() {
  yield takeEvery(ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST, onAcquisitionDetailSearchAcquisitionDetailTypeList);
}

export function* watchAcquisitionDetailSearchDemandList() {
  yield takeEvery(ACQUISITION_DETAIL_SEARCH_DEMAND_LIST, onAcquisitionDetailSearchDemandList);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAcquisitionDetailListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'acquisition_detail/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAcquisitionDetailSearchArticleGroupListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/article_group', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAcquisitionDetailDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'acquisition_detail/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAcquisitionDetailSearchProjectListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/project', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};


const onAcquisitionDetailSearchAcquisitionListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/acquisition', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAcquisitionDetailSearchYearListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/year', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAcquisitionDetailSearchAcquisitionDetailTypeListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/acquisition_detail_type', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAcquisitionDetailSearchDemandListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/demand', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

function* onAcquisitionDetailList(data) {
  try {
    const response = yield call(onAcquisitionDetailListAsync, data.payload);
    yield put(AcquisitionDetailListSuccess(response.data));
  } catch (error) {
    yield put(AcquisitionDetailListError(error));
  }
}

function* onAcquisitionDetailDetail(data) {
  try {
    const response = yield call(onAcquisitionDetailDetailAsync, data.payload);
    yield put(AcquisitionDetailDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AcquisitionDetailDetailError(error));
  }
}


function* onAcquisitionDetailSearchArticleGroupList(data) {
  try {
    const response = yield call(onAcquisitionDetailSearchArticleGroupListAsync, data);
    yield put(AcquisitionDetailSearchArticleGroupListSuccess(response.data));
  } catch (error) {
    yield put(AcquisitionDetailSearchArticleGroupListError(error));
  }
}

function* onAcquisitionDetailSearchProjectList(data) {
  try {
    const response = yield call(onAcquisitionDetailSearchProjectListAsync, data);
    yield put(AcquisitionDetailSearchProjectListSuccess(response.data));
  } catch (error) {
    yield put(AcquisitionDetailSearchProjectListError(error));
  }
}

function* onAcquisitionDetailSearchAcquisitionList(data) {
  try {
    const response = yield call(onAcquisitionDetailSearchAcquisitionListAsync, data);
    yield put(AcquisitionDetailSearchAcquisitionListSuccess(response.data));
  } catch (error) {
    yield put(AcquisitionDetailSearchAcquisitionListError(error));
  }
}

function* onAcquisitionDetailSearchYearList(data) {
  try {
    const response = yield call(onAcquisitionDetailSearchYearListAsync, data);
    yield put(AcquisitionDetailSearchYearListSuccess(response.data));
  } catch (error) {
    yield put(AcquisitionDetailSearchYearListError(error));
  }
}

function* onAcquisitionDetailSearchAcquisitionDetailTypeList(data) {
  try {
    const response = yield call(onAcquisitionDetailSearchAcquisitionDetailTypeListAsync, data);
    yield put(AcquisitionDetailSearchAcquisitionDetailTypeListSuccess(response.data));
  } catch (error) {
    yield put(AcquisitionDetailSearchAcquisitionDetailTypeListError(error));
  }
}

function* onAcquisitionDetailSearchDemandList(data) {
  try {
    const response = yield call(onAcquisitionDetailSearchDemandListAsync, data);
    yield put(AcquisitionDetailSearchDemandListSuccess(response.data));
  } catch (error) {
    yield put(AcquisitionDetailSearchDemandListError(error));
  }
}
export default function* rootSaga() {
  yield all([
    fork(watchAcquisitionDetailList),
    fork(watchAcquisitionDetailSearchArticleGroupList),
    fork(watchAcquisitionDetailSearchProjectList),
    fork(watchAcquisitionDetailSearchAcquisitionList),
    fork(watchAcquisitionDetailSearchYearList),
    fork(watchAcquisitionDetailDetail),
    fork(watchAcquisitionDetailSearchAcquisitionDetailTypeList),
    fork(watchAcquisitionDetailSearchDemandList)
  ]);
}